import { RelatedLP } from '../RelatedPages';
export default function Page() { return <RelatedLP slug="the-butler" locale="ja" />; }
